export class CompanyMasterData {
  private staging: boolean;
  private fiscalNumber: string;
  private companyInfo: CompanyMasterDataInfo;
  private geoLocation: GeoLocation;
  private federalOfficerInfo: FederalOfficerInfo;
  private corporateName: string;
  private tradingName: string;
  private contract: string;
  private branch: string;
  private subBranch: string;
  private type: string;
  private drugFront: string;
  private cluster: string;
  private situation: string;

  isStaging(): boolean {
    return this.staging;
  }

  companyInStaging() {
    this.staging = true;
  }

  companyProcessed() {
    this.staging = false;
  }

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setCompanyInfo(value: CompanyMasterDataInfo): void {
    this.companyInfo = value;
  }

  getCompanyInfo(): CompanyMasterDataInfo {
    return this.companyInfo;
  }

  setGeoLocation(value: GeoLocation): void {
    this.geoLocation = value;
  }

  getGeoLocation(): GeoLocation {
    return this.geoLocation;
  }

  setFederalOfficerInfo(value: FederalOfficerInfo): void {
    this.federalOfficerInfo = value;
  }

  getFederalOfficerInfo(): FederalOfficerInfo {
    return this.federalOfficerInfo;
  }

  setCorporateName(value: string): void {
    this.corporateName = value;
  }

  getCorporateName(): string {
    return this.corporateName;
  }

  setTradingName(value: string): void {
    this.tradingName = value;
  }

  getTradingName(): string {
    return this.tradingName;
  }

  setContract(value: string): void {
    this.contract = value;
  }

  getContract(): string {
    return this.contract;
  }

  setBranch(value: string): void {
    this.branch = value;
  }

  getBranch(): string {
    return this.branch;
  }

  setSubBranch(value: string): void {
    this.subBranch = value;
  }

  getSubBranch(): string {
    return this.subBranch;
  }

  setType(value: string): void {
    this.type = value;
  }

  getType(): string {
    return this.type;
  }

  setDrugFront(value: string): void {
    this.drugFront = value;
  }

  getDrugFront(): string {
    return this.drugFront;
  }

  setCluster(value: string): void {
    this.cluster = value;
  }

  getCluster(): string {
    return this.cluster;
  }

  setSituation(value: string): void {
    this.situation = value;
  }

  getSituation(): string {
    return this.situation;
  }
}

export class CompanyMasterDataInfo {
  private address: AddressMasterData[];
  private emails: string[];
  private telephones: string[];

  setAddress(value: AddressMasterData[]): void {
    this.address = value;
  }

  getAddress(): AddressMasterData[] {
    return this.address;
  }

  setEmais(value: string[]): void {
    this.emails = value;
  }

  getEmails(): string[] {
    return this.emails;
  }

  setTelephones(value: string[]): void {
    this.telephones = value;
  }

  getTelephones(): string[] {
    return this.telephones;
  }
}

export class AddressMasterData {
  private streetType: string;
  private street: string;
  private number: string;
  private complement: string;
  private zipCode: string;
  private district: string;
  private city: string;
  private state: string;
  private isNewAddress: boolean;

  getIsNewAddress(): boolean {
    return this.isNewAddress;
  }

  setIsNewAddress(value: boolean){
    this.isNewAddress = value;
  }

  setStreetType(value: string): void {
    this.streetType = value;
  }

  getStreetType(): string {
    return this.streetType;
  }

  getStreet(): string {
    return this.street;
  }

  setStreet(value: string): void {
    this.street = value;
  }

  getNumber(): string {
    return this.number;
  }

  setNumber(value: string): void {
    this.number = value;
  }

  getComplement(): string {
    return this.complement;
  }

  setComplement(value: string): void {
    this.complement = value;
  }

  getZipCode(): string {
    return this.zipCode;
  }

  setZipCode(value: string): void {
    this.zipCode = value;
  }

  getDistrict(): string {
    return this.district;
  }

  setDistrict(value: string): void {
    this.district = value;
  }

  getCity(): string {
    return this.city;
  }

  setCity(value: string): void {
    this.city = value;
  }

  getState(): string {
    return this.state;
  }

  setState(value: string): void {
    this.state = value;
  }
}

export class GeoLocation {
  private latitude: number;
  private longitude: number;

  setLatitude(value: number): void {
    this.latitude = value;
  }

  getLatitude(): number {
    return this.latitude;
  }

  setLongitude(value: number): void {
    this.longitude = value;
  }

  getLongitude(): number {
    return this.longitude;
  }
}

export class FederalOfficerInfo {
  private fiscalNumberRoot: string;
  private conditionDate: string;
  private companySize: string;
  private opened: string;
  private legalNature: string;
  private lastUpdated: string;
  private status: string;
  private statusMessage: string;
  private responsibleFederalEntity: string;
  private conditionReason: string;
  private specialCondition: string;
  private specialConditionDate: string;
  private shareCapital: string;
  private billing: CompanyFederalOfficerBillingInfo;
  private activities: CompanyFederalOfficerActivityInfo[];
  private socialPartners: CompanyFederalOfficerSocialPartnerInfo[];

  setFiscalNumberRoot(value: string): void {
    this.fiscalNumberRoot = value;
  }

  getFiscalNumberRoot(): string {
    return this.fiscalNumberRoot;
  }

  setConditionDate(value: string): void {
    this.conditionDate = value;
  }

  getConditionDate(): string {
    return this.conditionDate;
  }

  setCompanySize(value: string): void {
    this.companySize = value;
  }

  getCompanySize(): string {
    return this.companySize;
  }

  setOpened(value: string): void {
    this.opened = value;
  }

  getOpened(): string {
    return this.opened;
  }

  setLegalNature(value: string): void {
    this.legalNature = value;
  }

  getLegalNature(): string {
    return this.legalNature;
  }

  setLastUpdated(value: string): void {
    this.lastUpdated = value;
  }

  getLastUpdated(): string {
    return this.lastUpdated;
  }

  setStatus(value: string): void {
    this.status = value;
  }

  getStatus(): string {
    return this.status;
  }

  setStatusMessage(value: string): void {
    this.statusMessage = value;
  }

  getStatusMessage(): string {
    return this.statusMessage;
  }

  setResponsibleFederalEntity(value: string): void {
    this.responsibleFederalEntity = value;
  }

  getResponsibleFederalEntity(): string {
    return this.responsibleFederalEntity;
  }

  setConditionReason(value: string): void {
    this.conditionReason = value;
  }

  getConditionReason(): string {
    return this.conditionReason;
  }

  setSpecialCondition(value: string): void {
    this.specialCondition = value;
  }

  getSpecialCondition(): string {
    return this.specialCondition;
  }

  setSpecialConditionDate(value: string): void {
    this.specialConditionDate = value;
  }

  getSpecialConditionDate(): string {
    return this.specialConditionDate;
  }

  setShareCapital(value: string): void {
    this.shareCapital = value;
  }

  getShareCapital(): string {
    return this.shareCapital;
  }

  setBilling(value: CompanyFederalOfficerBillingInfo): void {
    this.billing = value;
  }

  getBilling(): CompanyFederalOfficerBillingInfo {
    return this.billing;
  }

  setActivities(value: CompanyFederalOfficerActivityInfo[]): void {
    this.activities = value;
  }

  getActivities(): CompanyFederalOfficerActivityInfo[] {
    return this.activities;
  }

  setSocialPartners(value: CompanyFederalOfficerSocialPartnerInfo[]): void {
    this.socialPartners = value;
  }

  getSocialPartners(): CompanyFederalOfficerSocialPartnerInfo[] {
    return this.socialPartners;
  }
}

export class CompanyFederalOfficerBillingInfo {
  private free: boolean;
  private database: boolean;

  setFree(value: boolean): void {
    this.free = value;
  }

  getFree(): boolean {
    return this.free;
  }

  setDatabase(value: boolean): void {
    this.database = value;
  }

  getDatabase(): boolean {
    return this.database;
  }
}

export class CompanyFederalOfficerActivityInfo {
  private code: string;
  private text: string;

  setCode(value: string): void {
    this.code = value;
  }

  getCode(): string {
    return this.code;
  }

  setText(value: string): void {
    this.text = value;
  }

  getText(): string {
    return this.text;
  }
}

export class CompanyFederalOfficerSocialPartnerInfo {
  private what: string;
  private name: string;

  setWhat(value: string): void {
    this.what = value;
  }

  getWhat(): string {
    return this.what;
  }

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }
}
